import type {
  INotificationPreferenceRepository,
  NotificationCategoryPreference,
} from '@yawi/domain';
import type { NotificationCategory } from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

export class ApiNotificationPreferenceRepository implements INotificationPreferenceRepository {
  private get client() { return getApiClient(); }

  async list(): Promise<NotificationCategoryPreference[]> {
    // TODO: confirm endpoint path with backend
    return this.client.get<NotificationCategoryPreference[]>('v1/notifications/preferences/categories');
  }

  async update(
    category: NotificationCategory,
    patch: Partial<Omit<NotificationCategoryPreference, 'category' | 'updatedAt'>>
  ): Promise<NotificationCategoryPreference> {
    return this.client.patch<NotificationCategoryPreference>(
      `v1/notifications/preferences/categories/${category}`,
      patch
    );
  }
}
